import React from "react";
import { IconBaseProps } from "react-icons";

export const ProfileSVG: React.FC<IconBaseProps> = ({ fill = "currentColor", size = 26 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 26 26"
    fill={fill}
    fillRule="evenodd"
    display="block"
  >
    <g transform="translate(5 3)">
      <path d="M12.043 9.438a6.315 6.315 0 0 1-4.304 1.67 6.315 6.315 0 0 1-4.304-1.67C1.357 11.088 0 13.656 0 15.64c0 3.153 1.166 4.197 7.739 4.197s7.739-1.044 7.739-4.197c0-1.984-1.357-4.552-3.435-6.202z" />
      <ellipse cx="7.739" cy="4.865" rx="4.94" ry="4.865" />
    </g>
  </svg>
);
